import DeleteConfirmModal from './DeleteConfirmModal.container';

export default DeleteConfirmModal;
